import { Component, inject, input, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';

import { DeviceService } from '@app/shared/services/shared/device.service';
import { GroupingModeEnum, ReportColumnsEnum } from '@app/shared/types/models/reports/time-report-panel.model';
import { TimeReportRowVM } from '@app/shared/types/models/reports/time-report-row.model';
import { TranslatePipe } from '@ngx-translate/core';
import { TimeReportFiltersExpandComponent } from '../time-report-filters-expand/time-report-filters-expand.component';
import { TimeReportExcelExportComponent } from './time-report-excel-export/time-report-excel-export.component';

@Component({
  selector: 'proffeo-reports-table-toolbar',
  imports: [
    MatIconModule,
    MatMenuModule,
    TimeReportExcelExportComponent,
    UiButtonComponent,
    MatButtonModule,
    TranslatePipe,
    TimeReportFiltersExpandComponent
  ],
  templateUrl: './reports-table-toolbar.component.html'
})
export class ReportsTableToolbarComponent {
  protected readonly isMobile = inject(DeviceService).isMobile;
  protected readonly GroupingModeEnum = GroupingModeEnum;

  public showFilters = signal(false);
  public selectedTimeReportIds = input<string[]>([]);
  public selectedGroupingMode = input.required<GroupingModeEnum>();
  public sessionsToggled = input<boolean>(false);
  public timeReportRows = input.required<TimeReportRowVM[]>();
  public visibleTableColumns = input.required<ReportColumnsEnum[]>();

  public changeGroupingMode = output<GroupingModeEnum>();
  public expandAll = output<void>();
  public hideAll = output<void>();
  public addReport = output<void>();
  public addAbsenceReport = output<void>();
  public approveReports = output<void>();
  public clearFilters = output<void>();
  public applyFilters = output<void>();

  protected emitChangeGroupingMode(groupingMode: GroupingModeEnum): void {
    this.changeGroupingMode.emit(groupingMode);
  }

  protected toggleFilters(showFilters?: boolean): void {
    if (showFilters === undefined) {
      this.showFilters.set(!this.showFilters());
    } else {
      this.showFilters.set(showFilters);
    }
  }

  protected onClearFilters(): void {
    this.clearFilters.emit();
  }

  protected emitReport(): void {
    this.addReport.emit();
  }

  protected emitAbsenceReport(): void {
    this.addAbsenceReport.emit();
  }

  protected emitApproveReports(): void {
    this.approveReports.emit();
  }
}
